//@ts-nocheck
'use client';
import dynamic from 'next/dynamic';
import { prismicLandingPageParser } from '../../../helpers/prismic';
import React from 'react';
import { PrismicDocument } from '@prismicio/types';
import { SliceZoneContext } from '@app/lib/prismic/types/slice-zone-context';

const LegacySliceHandler = ({
    document,
    context,
}: {
    document: PrismicDocument;
    context: SliceZoneContext;
}) => {
    let markup;
    switch (document.type) {
        case 'information_page':
            const InformationPageBlock = dynamic(
                () => import('../../../containers/Prismic/InformationPageBlock')
            );
            markup = <InformationPageBlock document={document} />;
            break;
        case 'stockist':
            const StockistEmbed = dynamic(
                () => import('../../../components/StockistEmbed')
            );
            markup = <StockistEmbed />;
            break;
        default:
            const PrismicSliceRenderer = dynamic(
                () => import('../legacy-slice-renderer/legacy-slice-renderer')
            );
            markup = (
                <PrismicSliceRenderer
                    isMobile={false}
                    isTablet={false}
                    blocks={
                        document && document.data
                            ? prismicLandingPageParser(document, 'uid')
                            : []
                    }
                    context={context}
                />
            );
            break;
    }
    return markup;
};

export default LegacySliceHandler;
